// TABSY TUDO
document.addEventListener('DOMContentLoaded', () => {
    const triggers = document.querySelectorAll('.tudoo-tab-trigger');
    const panels = document.querySelectorAll('.tudoo-tab-panel');
    const orangeCard = document.querySelector('.tudoo-orange-card');

    triggers.forEach((btn) => {
        btn.addEventListener('click', () => {
            const targetId = btn.getAttribute('data-target');

            // 1. Zmiana klas active
            triggers.forEach((t) => t.classList.remove('active'));
            panels.forEach((p) => p.classList.remove('active'));

            btn.classList.add('active');
            const targetPanel = document.getElementById(targetId);
            if (targetPanel) targetPanel.classList.add('active');

            // 2. Scroll tylko na mobilkach / małych ekranach (< 1200px)
            if (window.innerWidth < 1200 && orangeCard) {
                orangeCard.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                });
            }
        });
    });
});

// tabs czy to dla Ciebie
document.addEventListener('DOMContentLoaded', () => {
    const mainCard = document.getElementById('tudo_main_card');
    const triggers = document.querySelectorAll('.trigger_tab_homepage_tudo');
    const panels = document.querySelectorAll('.panel_tab_homepage_tudo');

    if (!mainCard) return;

    // Funkcja ustawiająca kolor
    const applyState = (index) => {
        const activePanel = panels[index];
        const activeTrigger = triggers[index];
        const color = activePanel.getAttribute('data_color');

        // 1. Obsługa paneli
        panels.forEach((p) => p.classList.remove('active'));
        activePanel.classList.add('active');

        // 2. Obsługa przycisków
        triggers.forEach((t) => {
            t.classList.remove('active');
            t.style.background = ''; // Czyścimy inline style nieaktywnych
        });
        activeTrigger.classList.add('active');
        activeTrigger.style.background = color;

        // 3. Obsługa karty głównej
        mainCard.style.background = color;
    };

    // Inicjalizacja pierwszej zakładki
    if (triggers.length > 0) {
        applyState(0);
    }

    triggers.forEach((btn, index) => {
        btn.addEventListener('click', () => {
            applyState(index);

            // Scroll na mobilkach
            if (window.innerWidth < 1200) {
                mainCard.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        });
    });
});

// obsluga slajderow testimonials oraz platofrma
document.addEventListener('DOMContentLoaded', function () {
    // 1. Swiper Opinii
    const testimonialSwiper = new Swiper('.testimonials-swiper', {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        autoplay: { delay: 5000, disableOnInteraction: false },
        navigation: {
            nextEl: '.testimonials .swiper-button-next',
            prevEl: '.testimonials .swiper-button-prev',
        },
    });

    // 2. Swiper Platformy - FIX DLA BLOKADY NEXT I DRAG
    const platformaSwiper = new Swiper('.platforma-swiper', {
        loop: true,
        loopedSlides: 4,

        autoplay: {
            delay: 5500,
            disableOnInteraction: false,
        },
        grabCursor: true, // Poprawia drag & drop

        navigation: {
            nextEl: '.platforma .swiper-button-next',
            prevEl: '.platforma .swiper-button-prev',
        },

        // Breakpoints
        breakpoints: {
            0: {
                slidesPerView: 1,
                spaceBetween: 15,
            },
            1200: {
                slidesPerView: 3,
                spaceBetween: 15,
                loopedSlides: 2,
            },
        },

        // Wymuszenie aktualizacji po załadowaniu
        on: {
            init: function () {
                this.update();
            },
        },
    });
});
